<template>
  <div v-if="isGetUserInfo == true">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { xPost } from '@/http/axios'

  export default {
    data: () => ({
      myDom: {
        params: {},
      },
      userData: [],
      isGetUserInfo: false
    }),
    computed: {
      // # ms - change
      ...mapState(['msal']),
      // myDB () {
      //   return this.lodash.get(this.myDom, ['params', 'db']) || ''
      // },
    },
    async mounted () {
      this.postCheckToken()
    },
    created () {
      this.$eventBus.$on('check-access', this.postCheckToken)
    },
    beforeDestroy () {
      this.$eventBus.$off('check-access', this.postCheckToken)
    },
    // beforeMount () {
    //   this.myDom.params = this.$route.meta instanceof Object ? this.$route.meta : {}
    // },
    methods: {
      ...mapActions([
        'setUserEmail',
        // # ms - add
        'setAccess'
      ]),
      // # ms - change
      // ------------------
      getMsalAuth () {
        // get email
        this.$eventBus.$emit(
          'msal-get-access',
          null,
          access => {
            this.getMsalUserInfo(access)
          }
        )
      },
      async getMsalUserInfo (access) {
        const done = this.lodash.get(access, 'done')
        const email = this.lodash.get(access, 'email')
        const accessToken = this.lodash.get(access, 'accessToken')
        const homeId = this.lodash.get(access, 'homeId')
        let userInfo = {}
        if (done && email && accessToken && homeId) {
          this.setAccess({ accessToken, homeId })
          let response = await this.axios({
            method: 'get',
            url: this.msal.graphApi + '/me',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': accessToken
            }
          })
          let imageData = ''
          try {
            let responseImg = await this.axios({
              method: 'get',
              url: this.msal.graphApi +
                '/me/photos/48x48/$value',
              headers: {
                'Content-Type': 'image/jpg',
                'Authorization': accessToken
              },
              responseType: 'arraybuffer' // important!!!
            })
            imageData = this.lodash.get(responseImg, 'data')
          } catch {
            // do nothing
          }
          let binary = ''
          const unit8Image = new Uint8Array(imageData)
          for (let i = 0; i < unit8Image.byteLength; i++) {
            binary += String.fromCharCode(unit8Image[i])
          }
          const base64Image =
            binary
              ? 'data:image/jpeg;base64,' + window.btoa(binary)
              : ''
          userInfo = {
            msId: (this.lodash.get(response, 'data.id') ?? ''),
            email: (this.lodash.get(response, 'data.mail') ?? '').toLowerCase(),
            Name: (this.lodash.get(response, 'data.displayName') ?? ''),
            Avatar: base64Image,
          }
        }
        this.handleUserInfo(userInfo)
      },
      async handleUserInfo (userInfo) {
        if (userInfo && userInfo.email) {
          let userRole = ''
          let userCiRole = ''
          let userBasesRole = ''
          // let roleType = ''
          const date = new Date()
          const y = date.getFullYear()
          // if (y === 2022) {
          //   this.$router.push('op/tables/login')
          // } else {
          try {
            const req = xPost(
              'list',
              'getUser',
              {
                userinfo: userInfo,
                // db: this.myDB,
              })
            const res = await req
            if (res.status === 200 && res.data.status === 200) {
              userRole = res.data.role.Role
              userCiRole = res.data.role.ci_Role
              userBasesRole = res.data.role.bases_Role
              // roleType = JSON.parse(res.data.role.userType).userType
            }
          } catch (err) {
            console.log(err)
            this.snackbarMassage = '1233'
            this.snackbar = true
            this.snackbarColor = 'error'
            this.comfirmUploading = false
          }
          if (this.$route.path === '/op/tables/login') {
            this.$router.push('/')
            // this.$router.push('/tables/setting')
          }
          if (!userRole && !userCiRole && !userBasesRole) { this.$router.push('/op/tables/login') }
          this.setUserEmail({
            email: userInfo.email,
            msId: userInfo.msId,
            Name: userInfo.Name,
            Avatar: userInfo.Avatar,
            Role: userRole,
            ci_Role: userCiRole,
            bases_Role: userBasesRole
            // RoleType: roleType
          })
          // Add into sperate pages (in the future)
          if ((this.$route.path === '/op/tables/setting' || this.$route.path === '/op/tables/op' 
            || this.$route.path === '/op/tables/viewdata' || this.$route.path === '/op/access/role'
            || this.$route.path === '/op/tables/aim') 
            && (userRole !== '-1' && userRole !== '0' && userRole !== '1' && userRole !== '2' && userRole !== '3')) {
            this.$router.push('/')
          }
          if ((this.$route.path === '/op/tables/ci-setting' || this.$route.path === '/op/tables/ci-op' 
            || this.$route.path === '/op/tables/ci-viewdata' || this.$route.path === '/op/access/ci-role'
            || this.$route.path === '/op/tables/ci-aim') 
            && (userCiRole !== '-1' && userCiRole !== '0' && userCiRole !== '1' && userCiRole !== '2' && userCiRole !== '3')) {
            this.$router.push('/')
            // console.log(userCiRole)
          }
          if ((this.$route.path === '/op/tables/bases-setting' || this.$route.path === '/op/tables/bases-op' 
            || this.$route.path === '/op/tables/bases-viewdata' || this.$route.path === '/op/access/bases-role'
            || this.$route.path === '/op/tables/bases-aim') 
            && (userBasesRole !== '-1' && userBasesRole !== '0' && userBasesRole !== '1' && userBasesRole !== '2' && userBasesRole !== '3')) {
            this.$router.push('/')
          }
          if ((userRole !== '-1' && userRole !== '0') && (this.$route.path === '/op/tables/setting' || this.$route.path === '/op/tables/aim')) {
            this.$router.push('/')
          }
          if ((userRole !== '-1' && userRole !== '1' && userRole !== '0') && this.$route.path === '/op/tables/role') {
            this.$router.push('/')
          }
          if ((userCiRole !== '-1' && userCiRole !== '0') && (this.$route.path === '/op/tables/ci-setting' || this.$route.path === '/op/tables/ci-aim')) {
            this.$router.push('/')
          }
          if ((userCiRole !== '-1' && userCiRole !== '1' && userCiRole !== '0') && this.$route.path === '/op/tables/ci-role') {
            this.$router.push('/')
          }
          if ((userBasesRole !== '-1' && userBasesRole !== '0') && (this.$route.path === '/op/tables/bases-setting' || this.$route.path === '/op/tables/bases-aim')) {
            this.$router.push('/')
          }
          if ((userBasesRole !== '-1' && userBasesRole !== '1' && userBasesRole !== '0') && this.$route.path === '/op/tables/bases-role') {
            this.$router.push('/')
          }
          if (userRole !== '-1' && this.$route.path === '/op/tables/maintenance') {
            this.$router.push('/')
          }
          if (userCiRole !== '-1' && this.$route.path === '/op/tables/ci-maintenance') {
            this.$router.push('/')
          }
          if (userBasesRole !== '-1' && this.$route.path === '/op/tables/bases-maintenance') {
            this.$router.push('/')
          }
        } else {
          if (this.$route.path !== '/op/tables/login') {
            this.$router.push('/op/tables/login')
          }
        }
        this.isGetUserInfo = true
      },
      postCheckToken () {
        this.getMsalAuth()
      }
      // ------------------
    }
  }
</script>

<style>

</style>
